import CityPageTemplate from "../city-template/CityPageTemplate";
import { huronConfig } from "./data";

export default function HuronPage() {
  return <CityPageTemplate config={huronConfig} />;
}